import React, { Component } from 'react';

import { Row, Col} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import Responsive from 'react-responsive';


// JS Files
import Navbar           from "../../MainComponents/CommonCom/Navbar.js";
import IntroText        from "../../MainComponents/AboutUsCom/IntroductionCom/IntroText.js";
import ChooseUS         from "../../MainComponents/AboutUsCom/IntroductionCom/ChooseUS.js";
import Goals            from "../../MainComponents/AboutUsCom/IntroductionCom/Goals.js";
import MissStatement    from "../../MainComponents/AboutUsCom/IntroductionCom/MissStatement.js";
import Strategy         from "../../MainComponents/AboutUsCom/IntroductionCom/Strategy.js";
import Vision           from "../../MainComponents/AboutUsCom/IntroductionCom/Vision.js";
import TimeLine         from "../../MainComponents/AboutUsCom/IntroductionCom/TimeLine.js";
import Footer           from "../../MainComponents/CommonCom/Footer.js";

import {MobileHPMenu}     from "../../Statics/HomePage/MobileHPMenu.js";

// Responsive Part
const LaptopDesktop = props => <Responsive {...props} minWidth={769} />;
const Tablet = props => <Responsive {...props} minWidth={426} maxWidth={768} />;
const Mobile = props => <Responsive {...props} maxWidth={425} />;

class Introduction extends Component {
     componentDidMount = () => {
          MobileHPMenu()
     }
     render() {
          
          return (
               <div>
                    <Mobile>
                         <div>
                              <Navbar history={this.props.history}/>
                              <IntroText />
                              <ChooseUS />
                              <Margin top={3}></Margin>
                              <Goals />
                              <Margin top={2}></Margin>
                              <MissStatement />
                              <Margin top={2}></Margin>
                              <Strategy />
                              <Margin top={2}></Margin>
                              <Vision />
                              <TimeLine />
                              <Margin top={3}></Margin>
                              <Footer  history={this.props.history}/>

                         </div>
                    </Mobile>
                    <Tablet>
                         <div>
                              <Navbar size="tablet" history={this.props.history}/>
                              <IntroText size="tablet" />
                              <ChooseUS size="tablet" />
                              <Margin top={4} />
                              <Goals size="tablet" />
                              <Margin top={3}></Margin>
                              <MissStatement size="tablet" />
                              <Margin top={3}></Margin>
                              <Strategy size="tablet" />
                              <Margin top={3}></Margin>
                              <Vision size="tablet" />
                              <Margin top={3}></Margin>
                              <TimeLine size="tablet" />
                              <Margin top={4}></Margin>
                              <Footer size="tablet"  history={this.props.history}/>
                         </div>
                    </Tablet>
                    <LaptopDesktop>
                         <div>
                              <Navbar size="laptopdesktop" history={this.props.history}/>
                              <IntroText          size="laptopdesktop"/>
                              <ChooseUS           size="laptopdesktop"/>
                              <Margin top={4}/>
                              <Goals              size="laptopdesktop"/>
                              <MissStatement      size="laptopdesktop"/>
                              <Strategy           size="laptopdesktop"/>
                              <Vision             size="laptopdesktop"/>
                              <TimeLine           size="laptopdesktop"/>
                              <Margin top={5}></Margin>
                              <Footer             size="laptopdesktop"  history={this.props.history}/>
                         </div>
                    </LaptopDesktop>
               </div>
          );
     }
}
export default Introduction;
